import Axios from "axios";
import Swal from "sweetalert2";
import { handleSessionExpiration } from "./handleSessionExpiration";

export const token = () => {
    return window.localStorage.getItem('token');
}

export const config = () => {
    let token = window.localStorage.getItem('token');
    return {
        headers: {
            "Authorization": `Bearer ${token}`,
        }
    }
}

export const settings = () => {
    return {
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }
    }
}

const axios = Axios.create({
    baseURL: process.env.REACT_APP_URLAPI,
});

const isSessionExpired = (response) => {
    const message = response?.data?.message?.trim().toLowerCase();
    return response?.status === 401 ||
        message === "unauthenticated." ||
        message === "unauthenticated" ||
        message === "no autenticado." ||
        message === "no autenticado";
};

const isLoginRequest = (request) => {
    const path = request?.url?.split("?")[0].replace(/\/+$/, "");
    return path?.endsWith("/login") || path === "login";
};

const refreshSessionAndRetry = async (response, request) => {
    if (
        !isSessionExpired(response) ||
        !request ||
        request._sessionRefreshRetry ||
        request.skipSessionExpiration ||
        isLoginRequest(request) ||
        !localStorage.getItem("token")
    ) {
        return null;
    }

    request._sessionRefreshRetry = true;
    const newToken = await handleSessionExpiration(axios);
    if (!newToken) {
        return null;
    }

    request.headers = request.headers || {};
    request.headers.Authorization = `Bearer ${newToken}`;
    return axios(request);
};

axios.interceptors.response.use(
    async (response) => {
        const retriedResponse = await refreshSessionAndRetry(response, response.config);
        return retriedResponse || response;
    },
    async (error) => {
        const response = error.response;
        const retriedResponse = await refreshSessionAndRetry(response, error.config);
        return retriedResponse || Promise.reject(error);
    }
);
export default axios;

export const services = ({
    method,
    service,
    body,
    responseType = "json"
}) => {

    switch (method) {

        case "GET":

            return axios.get(service, {
                ...config(),
                responseType
            }).then((r) => {
                return response(r);
            }).catch((err) => {
                return response(err.response);
            });

        case "POST":

            return axios.post(service, body, {
                ...config(),
                responseType
            }).then((r) => {
                return response(r);
            }).catch((err) => {
                return response(err.response);
            });

        case "PUT":

            return axios.put(service, body, {
                ...config(),
                responseType
            }).then((r) => {
                return response(r);
            }).catch((err) => {
                return response(err.response);
            });

        case "DELETE":

            return axios.delete(service, {
                ...config(),
                responseType
            }).then((r) => {
                return response(r);
            }).catch((err) => {
                return response(err.response);
            });

        default:
            break;
    }
}
const arrayResponse = [
    200, 201, 404, 409, 422, 423, 500
];

const response = (r) => {

    if (r === undefined) {
        return false;
    }

    if (r.status === 401 && !localStorage.token) {
            Swal.fire({
                icon: 'error',
                title: 'credenciales invalidas',
                showConfirmButton: false,
                timer: 1000
              }).then((result) => {
                return false
            })
    }

    if (arrayResponse.includes(r.status)) {
        return { status: r.status, data: r.data }
    }

    return { status: r.status, errors: r.data.error }
}